import { connect } from "react-redux"
import View from "./view"
import { Store } from "utilities/Redux/store"
import { getAcceptedSellerOfferIds } from "modules/Seller/Offers/selectors"

const mapStateToProps = (state: Store) => ({
  offerIds: getAcceptedSellerOfferIds(state),
})

export default connect(mapStateToProps)(View)
